<template>
  <div class="w-full">
    <froala
        id="edit"
        v-model="editorContent"
        :config="config"
        dir="ltr"
    ></froala>
  </div>
</template>

<script>
import {getUserData} from "@/auth/utils";
import Helper from "@/libs/Helper";

export default {
  emits: ["getEditorContent"],
  props: {
    defaultEditorContent: {
      required: false,
    },
  },
  mounted() {
    if (this.defaultEditorContent) {
      setTimeout(() => {
        this.editorContent = this.defaultEditorContent;
      }, 300)
    }
  },
  watch: {
    editorContent: {
      handler(val) {
        this.$emit("getEditorContent", val);
      },
    },
  },
  data() {
    return {
      config: {
        videoUpload: true,
        baseUrl:Helper.baseUrl,
        toolbarSticky: true,
        attribution: false,
        imageUpload: true,
        imageUploadURL: `${Helper.baseUrl}api/Media/CreateFile`,
        // imageUploadParams: {
        //   ObjectId: -1,
        //   type: 8,
        //   mediaType: 30,
        //   alt: "",
        // },
        imageUploadParam: "base64",
        requestHeaders: {
          Authorization: getUserData().token,
        },
      },
      editorContent: null,
    };
  },
};
</script>

<style lang="scss">
.fr-view {
  height: 30rem;
}
</style>
